
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/autocomplete-option",
      function () {
        return require("private-next-pages/joy-ui/api/autocomplete-option.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/autocomplete-option"])
      });
    }
  